<template>
  <div>
    <b-navbar toggleable="lg" class="navbar-dark" fixed="top">

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <a class="navbar-brand clickable"><img src="../assets/logo_white_with_text.svg" alt=""></a>
        <b-navbar-nav v-if="$store.getters['isLoggedIn']" class="navbar__left">
          <b-nav-item :to="{ name: 'home' }">Home</b-nav-item>
          <b-nav-item :to="{ name: 'dashboard' }">Dashboard</b-nav-item>
          <b-nav-item v-if="$store.getters['isSuperadmin']" :to="{ name: 'list_of_users' }">Users</b-nav-item>
          <b-nav-item v-if="$store.getters['isSuperadmin']" :to="{ name: 'list_of_spaces' }">Spaces</b-nav-item>
          <b-nav-item v-if="$store.getters['isSuperadmin']" :to="{ name: 'list_of_projects' }">Projects</b-nav-item>
          <b-nav-item v-if="$store.getters['isSuperadmin']" :to="{ name: 'list_of_prototypes' }">Prototypes</b-nav-item>
          <b-nav-item v-if="$store.getters['isSuperadmin']" :to="{ name: 'list_of_otf_assets' }">OTF Assets</b-nav-item>
          <b-nav-item :to="{ name: 'list_of_logs' }">Logs</b-nav-item>
          <b-nav-item :to="{ name: 'database_functions' }">Database functions</b-nav-item>
          <b-nav-item @click="open_crash_reporter()">Crash reporter</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item as="span" class="toggle-snow" :class="{ active: letItSnow }" @click="toggleSnow" :hidden="!Date().includes('Dec')">
            {{ letItSnow ? '❄️ Let it snow ❄️' : '❄️ Turn of snow ❄️' }}
          </b-nav-item>
          <b-nav-item v-if="!$store.getters['isLoggedIn']" right :to="{ name: 'login' }">
            Login
          </b-nav-item>
          <b-nav-item v-else right @click="logout()">
            Logout
          </b-nav-item>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>
  </div>
</template>

<style lang="scss">
body {
  .navbar {
    background-color: #0a0294;
    color: white;
  }

  .navbar .nav-link {
    color: white !important;
  }

  .nav-item {
    padding-left: 0.5rem;
  }

  a {
    outline: none;
  }

  .navbar__left a {
    position: relative;
    text-decoration: none;
  }

  .nav-link:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: #18b4cfc0;
    visibility: hidden;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.3s ease-in-out 0s;
    transition: all 0.3s ease-in-out 0s;
  }

  .navbar__left .router-link-exact-active:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  .navbar__left a:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  .dropdown-menu {
    background-color: #1f2a45;
    color: white;
  }

  .dropdown-item {
    color: white;
    background-color: #1f2a45;
  }

  .dropdown-item:hover {
    color: white;
    background-color: #1f2a45;
  }

  .dropdown-item:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: #18b4cfc0;
    visibility: hidden;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.3s ease-in-out 0s;
    transition: all 0.3s ease-in-out 0s;
  }

}
</style>


<script>
import { mapMutations } from 'vuex';
import functions from '../main';

export default {
  data() {
    return {
      letItSnow: false, // Initial snow state
    };
  },
  methods: {
    ...mapMutations([
      'dropToken'
    ]),
    toggleSnow() {
      this.letItSnow = !this.letItSnow; // Toggle the snow state
      this.$emit('toggle-snow', this.letItSnow); // Emit to parent (App.vue)
    },
    logout() {
      this.$http.delete(this.$apiURL + '/auth/logout', { headers: { Authorization: "Bearer " + this.$store.getters.refreshToken } }
      )
        .catch((error) => {
          this.message = {
            'message': error,
            'type': "danger"
          }
        })
        .finally(() => {
          this.dropToken(true)
        });
    },
    async open_crash_reporter() {
      var querystring = require('querystring');

      await functions.refresh_token(this.$store.getters.accessToken)

      await this.$http.post(this.$crashReporterURL + '/auth_with_token', querystring.stringify({ access_token: this.$store.getters.accessToken }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
      )
        .then((res) => {
          if (res.data.token != undefined) {
            window.open(this.$crashReporterURL + '/authorize?token=' + res.data.token, "_blank");
          }
        })
        .catch((error) => {
          console.log(error)
          this.message = {
            'message': error.response.data,
            'type': "danger"
          }

        });
    }
  },
  mounted() {
    this.$store.subscribe(({ type }) => {
      if (type === 'dropToken') {
        this.$router.push({ name: "home" }).catch(() => { });
      }
    })
  }
}
</script>